import { FirebaseAuth } from '../../../../lib/firebase'

export const emailResetPassword = (email: string): Promise<void> =>
  FirebaseAuth.sendPasswordResetEmail(email)
